import { integrityHashes } from '../../../../../onetrust.config.json'

export const ONETRUST_SDK_INTEGRITY_HASHES = integrityHashes
